import React, { useState } from 'react';
import { Cpu, HardDrive, Database, Globe, Radio, MapPin, Shield, ShieldEllipsis, ShieldEllipsisIcon, HardDriveIcon, MemoryStick, UsersRound, HeartPlusIcon, DatabaseBackupIcon, LifeBuoyIcon } from 'lucide-react';
import './fivem.css';
import { Helmet } from "react-helmet";

interface PlanFeature {
  icon: React.ElementType;
  label: string;
  value: string;
}

interface PricingPlan {
  id: string;
  name: string;
  color: string;
  features: PlanFeature[];
  basePrice: number;
  popular?: boolean;
  orderLink?: string;
}

interface PricingPeriod {
  id: string;
  label: string;
  months: number;
  discount: number;
  badge?: string;
}

// Composants SVG pour les mobs Minecraft
const FiveM = () => (
    <svg width="60" height="60" viewBox="0 0 200 200" fill="none" className="mob-icon">
      <path
          d="M128.0000 53.0000L106.0000 75.0000L106.0000 81.0000L108.0000 85.0000L109.0000 92.0000L111.0000 96.0000L111.0000 99.0000L113.0000 103.0000L114.0000 110.0000L115.0000 111.0000L115.0000 113.0000L117.0000 117.0000L117.0000 120.0000L119.0000 124.0000L119.0000 127.0000L121.0000 131.0000L121.0000 134.0000L123.0000 138.0000L124.0000 145.0000L125.0000 146.0000L125.0000 148.0000L127.0000 152.0000L127.0000 155.0000L129.0000 159.0000L130.0000 166.0000L132.0000 170.0000L132.0000 173.0000L133.0000 174.0000L133.0000 177.0000L134.0000 178.0000L136.0000 186.0000L137.0000 187.0000L175.0000 187.0000L176.0000 186.0000L176.0000 182.0000L175.0000 181.0000L175.0000 179.0000L174.0000 178.0000L174.0000 176.0000L173.0000 175.0000L171.0000 167.0000L169.0000 164.0000L169.0000 162.0000L168.0000 161.0000L168.0000 159.0000L167.0000 158.0000L167.0000 156.0000L166.0000 155.0000L166.0000 153.0000L165.0000 152.0000L165.0000 150.0000L164.0000 149.0000L164.0000 147.0000L163.0000 146.0000L163.0000 144.0000L162.0000 143.0000L162.0000 141.0000L161.0000 140.0000L161.0000 138.0000L160.0000 137.0000L160.0000 135.0000L159.0000 134.0000L159.0000 132.0000L158.0000 131.0000L158.0000 129.0000L157.0000 128.0000L157.0000 126.0000L156.0000 125.0000L156.0000 123.0000L155.0000 122.0000L155.0000 120.0000L154.0000 119.0000L154.0000 117.0000L153.0000 116.0000L151.0000 108.0000L149.0000 105.0000L148.0000 99.0000L147.0000 98.0000L147.0000 96.0000L146.0000 95.0000L146.0000 93.0000L145.0000 92.0000L143.0000 84.0000L141.0000 81.0000L140.0000 75.0000L139.0000 74.0000L138.0000 69.0000L136.0000 66.0000L136.0000 63.0000L134.0000 60.0000L133.0000 54.0000L132.0000 53.0000ZM92.0000 93.0000L88.0000 93.0000L81.0000 100.0000L78.0000 100.0000L78.0000 103.0000L42.0000 139.0000L42.0000 141.0000L39.0000 147.0000L37.0000 155.0000L35.0000 158.0000L35.0000 161.0000L34.0000 162.0000L34.0000 164.0000L33.0000 165.0000L31.0000 173.0000L29.0000 176.0000L29.0000 178.0000L27.0000 182.0000L27.0000 186.0000L28.0000 187.0000L65.0000 187.0000L66.0000 186.0000L67.0000 180.0000L69.0000 176.0000L69.0000 173.0000L71.0000 169.0000L71.0000 166.0000L72.0000 165.0000L72.0000 163.0000L74.0000 159.0000L74.0000 156.0000L75.0000 155.0000L76.0000 149.0000L78.0000 145.0000L78.0000 142.0000L80.0000 138.0000L80.0000 135.0000L82.0000 131.0000L82.0000 128.0000L84.0000 124.0000L84.0000 121.0000L86.0000 117.0000L86.0000 114.0000L88.0000 110.0000L88.0000 107.0000L90.0000 103.0000L90.0000 100.0000L92.0000 96.0000ZM118.0000 16.0000L85.0000 16.0000L83.0000 18.0000L83.0000 20.0000L82.0000 21.0000L80.0000 29.0000L78.0000 32.0000L78.0000 34.0000L77.0000 35.0000L77.0000 37.0000L76.0000 38.0000L76.0000 40.0000L75.0000 41.0000L75.0000 43.0000L74.0000 44.0000L74.0000 46.0000L73.0000 47.0000L73.0000 49.0000L72.0000 50.0000L72.0000 52.0000L71.0000 53.0000L71.0000 55.0000L70.0000 56.0000L70.0000 58.0000L68.0000 62.0000L68.0000 68.0000L65.0000 71.0000L64.0000 76.0000L62.0000 79.0000L62.0000 81.0000L61.0000 82.0000L61.0000 84.0000L60.0000 85.0000L60.0000 87.0000L58.0000 91.0000L58.0000 94.0000L62.0000 94.0000L124.0000 32.0000L124.0000 30.0000L123.0000 29.0000L123.0000 25.0000L122.0000 24.0000L121.0000 19.0000L119.0000 19.0000L118.0000 18.0000ZM98.0000 67.0000L96.0000 67.0000L51.0000 112.0000L50.0000 116.0000L49.0000 117.0000L49.0000 121.0000L53.0000 121.0000L58.0000 116.0000L58.0000 115.0000L60.0000 113.0000L61.0000 113.0000L61.0000 112.0000L64.0000 109.0000L65.0000 109.0000L96.0000 78.0000L99.0000 72.0000L99.0000 69.0000ZM128.0000 40.0000L123.0000 40.0000L102.0000 61.0000L102.0000 67.0000L106.0000 68.0000L106.0000 67.0000L108.0000 65.0000L109.0000 65.0000L109.0000 64.0000L111.0000 63.0000L122.0000 52.0000L122.0000 51.0000L124.0000 49.0000L125.0000 49.0000L125.0000 48.0000L128.0000 45.0000Z"
          fill="white"
      />
    </svg>
);

const ZombieIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_zombie)">
        <path d="M58 0L30 15L58 30L86 15L58 0ZM25 45L35 50V80L25 75V45ZM91 45V75L81 80V50L91 45ZM40 55V85L58 95L76 85V55L58 65L40 55ZM20 85L30 90V110L20 105V85ZM96 85V105L86 110V90L96 85ZM35 95V115L58 105L81 115V95L58 100L35 95Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_zombie">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const BlazeIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_blaze)">
        <path d="M58 10L48 20L58 30L68 20L58 10ZM40 25L30 35L40 45L50 35L40 25ZM76 25L86 35L76 45L66 35L76 25ZM58 40L48 50L58 60L68 50L58 40ZM25 45L15 55L25 65L35 55L25 45ZM91 45L101 55L91 65L81 55L91 45ZM40 70L30 80L40 90L50 80L40 70ZM76 70L86 80L76 90L66 80L76 70ZM58 85L48 95L58 105L68 95L58 85Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_blaze">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const SpiderIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_spider)">
        <path d="M58 30C70 30 80 40 80 52C80 64 70 74 58 74C46 74 36 64 36 52C36 40 46 30 58 30ZM25 45L15 35L10 40L20 50L25 45ZM91 45L96 40L106 35L101 45L91 45ZM20 52L10 47L5 52L15 57L20 52ZM96 52L101 57L111 52L106 47L96 52ZM25 59L20 64L10 74L15 79L25 69L25 59ZM91 59L91 69L101 79L106 74L96 64L91 59Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_spider">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const EnderIcon = () => (
    <svg width="60" height="60" viewBox="0 0 116 116" fill="none" className="mob-icon">
      <g clipPath="url(#clip_ender)">
        <path d="M58 5L45 15L58 25L71 15L58 5ZM35 20L22 30L35 40L48 30L35 20ZM81 20L94 30L81 40L68 30L81 20ZM58 35L45 45L58 55L71 45L58 35ZM22 50L9 60L22 70L35 60L22 50ZM94 50L107 60L94 70L81 60L94 50ZM45 65L32 75L45 85L58 75L45 65ZM71 65L84 75L71 85L58 75L71 65ZM58 95L45 105L58 115L71 105L58 95Z"
              fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip_ender">
          <rect width="116" height="116"/>
        </clipPath>
      </defs>
    </svg>
);

const Price: React.FC = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');

  const periods: PricingPeriod[] = [
    { id: 'monthly', label: 'Par mois', months: 1, discount: 0 },
    { id: '3months', label: '3 mois', months: 3, discount: 0, badge: '-5%' },
    { id: '6months', label: '6 mois', months: 6, discount: 0, badge: '-5%' },
    { id: '1year', label: '1 an', months: 12, discount: 0, badge: '-5%' }
  ];

  const plans: PricingPlan[] = [
    {
      id: 'fivem-dev',
      name: 'Fivem | Dev',
      color: 'green',
      basePrice: 1.99,
      orderLink: 'https://client.hostware.fr/store/basket/add/22',
      features: [
        { icon: Cpu, label: 'CPU', value: '1 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 3 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '25 Go de stockage' },
        { icon: DatabaseBackupIcon, label: '1 Backup', value: '' },
        { icon: Database, label: 'Base de données MySQL', value: '1' },
        { icon: Radio, label: 'Bande passante', value: ' 10 GB/s' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
    {
      id: 'fivem-starter',
      name: 'Fivem | Starter',
      color: 'blue',
      basePrice: 3.99,
      orderLink: 'https://client.hostware.fr/store/basket/add/23',
      features: [
        { icon: Cpu, label: 'CPU', value: '2 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 5 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '35 Go de stockage' },
        { icon: DatabaseBackupIcon, label: '1 Backup', value: '' },
        { icon: Database, label: 'Base de données MySQL', value: '1' },
        { icon: Radio, label: 'Bande passante', value: ' 10 GB/s' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
    {
      id: 'fivem-lite',
      name: 'Fivem | Lite',
      color: 'yellow',
      basePrice: 12.99,
      orderLink: 'https://client.hostware.fr/store/basket/add/24',
      popular: true,
      features: [
        { icon: Cpu, label: 'CPU', value: '3 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 10 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '50 Go de stockage' },
        { icon: DatabaseBackupIcon, label: '1 Backup', value: '' },
        { icon: Database, label: 'Base de données MySQL', value: '1' },
        { icon: Radio, label: 'Bande passante', value: ' 10 GB/s' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
    {
      id: 'fivem-premium',
      name: 'Fivem | Premium',
      color: 'red',
      basePrice: 19.5,
      orderLink: 'https://client.hostware.fr/store/basket/add/25',
      features: [
        { icon: Cpu, label: 'CPU', value: '4 vCPU' },
        { icon: MemoryStick, label: 'RAM', value: ' 20 Go RAM' },
        { icon: HardDriveIcon, label: '', value: '70 Go de stockage' },
        { icon: DatabaseBackupIcon, label: '1 Backup', value: '' },
        { icon: Database, label: 'Base de données MySQL', value: '1' },
        { icon: Radio, label: 'Bande passante', value: ' 10 GB/s' },
        { icon: LifeBuoyIcon, label: 'Support prioritaire', value: '' },
        { icon: ShieldEllipsisIcon, label: 'Protection Anti-DDos', value: 'Protection' }
      ]
    },
  ];

  const getMobIcon = (planId: string) => {
    switch (planId) {
      case 'fivem': return <FiveM  />;
      case 'zombie': return <ZombieIcon />;
      case 'blaze': return <BlazeIcon />;
      case 'spider': return <SpiderIcon />;
      case 'ender': return <EnderIcon />;
      default: return <FiveM  />;
    }
  };

  // Fonction déplacée avant le return
  const calculatePrice = (basePrice: number, selectedPeriodId: string, planId: string) => {
    const period = periods.find(p => p.id === selectedPeriodId);
    if (!period) return { price: basePrice, total: basePrice, savings: 0 };

    const eligible = planId === 'fivem-lite' || planId === 'fivem-premium';
    const discount = (period.id !== 'monthly' && eligible) ? 5 : 0;

    const discountedPrice = basePrice * (1 - discount / 100);
    const totalPrice = discountedPrice * period.months;

    return {
      price: discountedPrice,
      total: totalPrice,
      savings: (period.months > 1 && discount > 0) ? (basePrice * period.months - totalPrice) : 0
    };
  };

  const getSelectedPeriod = () => periods.find(p => p.id === selectedPeriod);

  return (
      <>
        <Helmet>
          <title>HOSTWARE® – Hébergement Serveur FiveM performant dès 1.99€/mois</title>
          <meta
              name="description"
              content="Hébergez votre serveur FiveM avec CPU Intel dédié, TxAdmin préinstallé, Anti-DDoS L4/L7, sauvegardes automatiques et support 24/7. Offres à partir de 1.99€/mois chez HostWare."
          />
          <meta
              name="keywords"
              content="hébergement fivem, serveur fivem, vps gaming, serveur gta rp, hébergement jeu, fivem hosting, hébergement pas cher"
          />
          <meta
              name="title"
              content="Serveur FiveM performant & fiable - HostWare"
          />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="HostWare" />
          <meta property="og:locale" content="fr_FR" />
          <meta property="og:url" content="https://hostware.fr/fivem" />
          <meta property="og:title" content="HOSTWARE – Hébergement Serveur FiveM performant dès 1.99€/mois" />
          <meta
              property="og:description"
              content="Hébergez votre serveur FiveM avec CPU Intel dédié, TxAdmin préinstallé, Anti-DDoS L4/L7, sauvegardes automatiques et support 24/7. Offres dès 1.99€/mois."
          />
          <meta property="og:image" content="https://hostware.fr/logo512.png" />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="HOSTWARE – Hébergement Serveur FiveM performant dès 1.99€/mois" />
          <meta
              property="twitter:description"
              content="Hébergez votre serveur FiveM avec CPU Intel dédié, TxAdmin préinstallé, Anti-DDoS L4/L7, sauvegardes automatiques et support 24/7. Offres dès 1.99€/mois."
          />
          <meta property="twitter:image" content="https://hostware.fr/logo512.png" />
          <meta property="twitter:image:width" content="512" />
          <meta property="twitter:image:height" content="512" />
          <meta property="twitter:image:alt" content="Logo HostWare" />
        </Helmet>

        <div className="pricing-container">
          {/* Background Effects */}
          <div className="background-overlay"></div>
          <div className="background-orb orb-1"></div>
          <div className="background-orb orb-2"></div>
          <div className="floating-particles"></div>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <div className="rocket-icon animate-bounce-slow">🚀</div>
              <h1 className="hero-title animate-fade-in-up">
                DÉCOUVREZ NOS OFFRES
              </h1>
              <p className="hero-subtitle animate-fade-in-up" style={{animationDelay: '0.2s'}}>
                Louez votre serveur FiveM pour jouer avec vos amis ou en communauté. Profitez de performances exceptionnelles pour une expérience de jeu inoubliable.
              </p>

              {/* Duration Tabs */}
              <div className="duration-tabs animate-fade-in-up" style={{animationDelay: '0.4s'}}>
                {periods.map((period) => (
                    <button
                        key={period.id}
                        onClick={() => setSelectedPeriod(period.id)}
                        className={`duration-tab ${selectedPeriod === period.id ? 'active' : ''}`}
                    >
                      {period.label}
                      {period.badge && (
                          <span className="discount-badge animate-pulse-soft">
                      {period.badge}
                    </span>
                      )}
                    </button>
                ))}
              </div>
            </div>
          </div>

          {/* Pricing Cards */}
          <div className="pricing-section">
            <div className="plans-grid">
              {plans.map((plan, index) => {
                const pricing = calculatePrice(plan.basePrice, selectedPeriod, plan.id);
                const currentPeriod = getSelectedPeriod();

                return (
                    <div
                        key={plan.id}
                        className={`plan-card ${plan.color} ${plan.popular ? 'popular' : ''} animate-fade-in-up`}
                        style={{animationDelay: `${0.1 * index}s`}}
                    >
                      {/* Plan Header */}
                      <div className="plan-header">
                        <div className="plan-icon-container">
                          <FiveM />
                        </div>
                        <h3 className="plan-name">{plan.name}</h3>
                        {plan.popular && (
                            <div className="popular-badge animate-glow">
                              Populaire
                            </div>
                        )}
                      </div>

                      {/* Features */}
                      <div className="plan-features">
                        {plan.features.map((feature, featureIndex) => (
                            <div
                                key={featureIndex}
                                className="feature-row animate-slide-in-left"
                                style={{animationDelay: `${0.6 + featureIndex * 0.1}s`}}
                            >
                              <feature.icon className="feature-icon" size={16} />
                              <span className="feature-label">{feature.label}</span>
                              <span className="feature-value">{feature.value}</span>
                            </div>
                        ))}
                      </div>

                      {/* Pricing */}
                      <div className="plan-pricing">
                        <div className="price-display">
                          <div className="price animate-number-change">
                            {pricing.price.toFixed(2)} €
                          </div>
                          <div className="duration">{currentPeriod?.label}</div>
                        </div>

                        {currentPeriod && currentPeriod.months > 1 && (
                            <div className="pricing-details">
                              <div className="total-price">
                                Total: {pricing.total.toFixed(2)} €
                              </div>
                              {pricing.savings > 0 && (
                                  <div className="savings animate-pulse-soft">
                                    Économie: {pricing.savings.toFixed(2)} €
                                  </div>
                              )}
                            </div>
                        )}
                      </div>

                      {/* CTA Button */}
                      <a href={plan.orderLink} target="_blank" rel="noopener noreferrer" className="plan-button animate-button-hover">
                        <span>Commander</span>
                        <div className="button-shine"></div>
                      </a>
                    </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
  );
};

export default Price;